import * as React from 'react';

function SvgPasswordHide({ strokeWidth = '1.5' }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="18" viewBox="0 0 20 18" fill="none">
      <path
        d="M8 9C8 9.53043 8.21071 10.0391 8.58579 10.4142C8.96086 10.7893 9.46957 11 10 11C10.5304 11 11.0391 10.7893 11.4142 10.4142C11.7893 10.0391 12 9.53043 12 9C12 8.46957 11.7893 7.96086 11.4142 7.58579C11.0391 7.21071 10.5304 7 10 7C9.46957 7 8.96086 7.21071 8.58579 7.58579C8.21071 7.96086 8 8.46957 8 9Z"
        stroke="#8C9196"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19 9C16.6 13 13.6 15 10 15C6.4 15 3.4 13 1 9C3.4 5 6.4 3 10 3C13.6 3 16.6 5 19 9Z"
        stroke="#8C9196"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <line
        x1="2"
        y1="16.9393"
        x2="17.9393"
        y2="0.999999"
        stroke="#8C9196"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />
    </svg>
  )
}

export default SvgPasswordHide;
